import { createModel } from '@rematch/core';
import { QualificationInfoList } from '../../api/ApiClient';
import apiConnector from '../../api/ApiConnector';
import { IFilterPart, ISearchPart } from 'components/models';

const initialState: State = {
    qualificationList: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setQualificationList(state, qualificationList: QualificationInfoList): State {
            return { ...state, qualificationList };
        },
    },
    effects: (dispatch: any) => ({
        async getQualificationsAsync(payload: GetQualificationPayload & ISearchPart & IFilterPart) {
            const result = await apiConnector.execApi(
                dispatch,
                apiClient => apiClient.getQualifications(
                    payload.occupationalStandardId,
                    undefined,
                    undefined,
                    payload.searchField,
                    payload.searchTerm,
                    payload.page,
                    payload.pageSize,
                    payload.sortOrder,
                    payload.sortField,
                ),
            );
            if (!result) return;
            this.setQualificationList(result);
        },
    }),
});

interface State {
    qualificationList: QualificationInfoList | null;
}

interface GetQualificationPayload {
    occupationalStandardId?: string;
}
